/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.forms.init());

App.modal_ready(() => App.forms.init());

App.forms = {
  init() {
    $(document)
      .off('click', '.js-reenable-btn', App.forms.re_enable_button)
      .on('click', '.js-reenable-btn', App.forms.re_enable_button);


    $("select.selectize:not(.selectized)").each(function() {
      console.log('should be selectizing')
      const options = {};
      if (this.hasAttribute("multiple")) { options.plugins = ["remove_button"]; }
      if (this.hasAttribute("data-create")) { options.create  = App.forms.create_option; }

      return $(this).selectize(options);
    });
    App.forms.enable.init();
    return App.forms.multiEnable.init();
  },


  create_option(input) {
    return { value: input, text: input };
  },


  re_enable_button(evt) {
    const btn = $(this);
    return window.setTimeout(() => $.rails.enableFormElement(btn)
    , 2500);
  }
};


App.forms.enable = {
  init() {
    return $(document)
      .off("click", "[data-enable]", App.forms.enable.clicked)
      .on("click", "[data-enable]", App.forms.enable.clicked);
  },


  clicked(evt) {
    const cb = $(this);
    const target = $(cb.attr("data-enable"));
    target.prop("disabled", !cb.is(":checked"));

    if (cb.is(":checked")) {
      return target.removeAttr("disabled");
    } else {
      return target.attr("disabled", "disabled");
    }
  }
};


App.forms.multiEnable = {
  init() {
    return $(document)
      .off("click", "[data-multi-enable]", App.forms.multiEnable.clicked)
      .on("click", "[data-multi-enable]", App.forms.multiEnable.clicked);
  },


  clicked(evt) {
    const cb = $(this);
    const all_cbs = $(document).find(`input[data-multi-enable='${cb.attr("data-multi-enable")}']`);
    const result1 = all_cbs.toArray().map(t => t.checked);
    const result2 = result1.reduce((r, t) => r && t);

    const target = cb.attr("data-multi-enable");
    const node = document.getElementById(target);

    if (result2) {
      node.removeAttribute("disabled");
      // Submit external form with a label to support IE 11.
      if (target === "transfer-account-btn") {
        return $("#transfer-form-submit").click();
      }
    } else {
      return node.setAttribute("disabled", "disabled");
    }
  }
};
